export default {
  steps: {
    0: {
      title: 'Rupea kanta-asiakkaaksi',
      description: 'Katso tilaushistoriasi ja tilaa uudelleen yhdellä napautuksella.',
    },
    1: {
      title: 'Saat palkintoja',
      description: 'Seuraa pisteitäsi ja lunasta tallennetut palkinnot lompakostasi.',
    },
    2: {
      title: 'Tilaa etukäteen',
      description: 'Löydä lähin toimipiste ja tilaa nopeammin kuin koskaan.',
    },
  },
  buttons: {
    skip: 'Ohita',
  },
};
